<template>
    <v-list-item @click="emitClick()" :class="item.Active == 1 ? '' : 'deactivated'">
        <v-list-item-icon class="my-auto mr-4">
            <avatar :color="isMe ? 'red' : getUserTypeColor(item.UserTypeId)" :fullname="item.Name" small="true">
            </avatar>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>
                {{ item.Name }} {{ isMe ? $t("servicesystem.common_objects.user.is_you_indicator") : '' }}
            </v-list-item-title>
            <v-list-item-subtitle>
                {{ item.EmailAdress }} {{ item.UserLogonName != item.EmailAdress ? '(' + item.UserLogonName + ')' : ''
                }}
            </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content v-if="!isPhoneBool" style="max-width: 150px;">
            <UserTypeTextTemplate :id="item.UserTypeId" />
        </v-list-item-content>

        <v-list-item-action v-if="!isPhoneBool && getUserTypeIsNotCustomer(item.UserTypeId)" class="ma-0">
            <v-row no-gutters align="center" style="width: 230px;">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-text="item.IsTechnician ? 'mdi-calendar-account' : 'mdi-calendar-remove-outline'"
                            :color="item.IsTechnician ? '' : 'disabled'" class="mx-1" v-bind="attrs" v-on="on">
                        </v-icon>
                    </template>
                    <span>{{ item.IsTechnician ? $t("servicesystem.common_objects.user.is_bookable") :
                        $t("servicesystem.common_objects.user.is_not_bookable") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-text="item.AllowImportExport ? 'mdi-table-arrow-right' : 'mdi-table-off'"
                            :color="item.AllowImportExport ? '' : 'disabled'" class="mx-1" v-bind="attrs" v-on="on">
                        </v-icon>
                    </template>
                    <span>{{ item.AllowImportExport ? $t("servicesystem.common_objects.user.has_export_rights") :
                        $t("servicesystem.common_objects.user.has_no_export_rights") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-text="item.StoreId ? '$store' : 'mdi-store-off'"
                            :color="item.StoreId ? (!warehouseList || storeName ? '' : 'orange') : 'disabled'"
                            class="mx-1" v-bind="attrs" v-on="on">
                        </v-icon>
                    </template>
                    <span>{{ item.StoreId ? (storeName ||
                        $t("servicesystem.common_objects.user.unrecognized_warehouse"))
                        :
                        $t("servicesystem.common_objects.user.has_no_store_set") }}</span>
                </v-tooltip>
                <span v-if="item.StoreId && warehouseList"
                    style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 130px;"
                    :style="!warehouseList || storeName ? '' : 'color: orange !important;'">
                    {{ storeName || '?' }}
                </span>
            </v-row>
        </v-list-item-action>

        <v-list-item-action class="ma-0">
            <v-row no-gutters align="center">
                <!--
                <v-btn icon small>
                    <v-icon size="22">mdi-pencil</v-icon>
                </v-btn>
                -->
                <v-switch :input-value="item.Active" :loading="item.loading == 'Active'" :readonly="!!item.loading"
                    @click.stop="toggleUserActive()" dense class="mt-0 px-3 pt-1" hide-details>
                </v-switch>
                <!--
                <ActionMenu v-if="true" :actionList="actionlist" :parentcontext="thiscontext">
                </ActionMenu>
                -->
            </v-row>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import UserTypeMixin from "@/helpers/Mixins/UserTypeMixin";
//import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import Avatar from "@/components/Buttons/Avatar.vue";
import UserTypeTextTemplate from "@/components/UserTypeTextTemplate.vue";

export default {
    name: "UserListItem",
    props: {
        item: Object,
        warehouseList: Array,
        isMe: Boolean,
    },
    components: {
        //ActionMenu,
        Avatar,
        UserTypeTextTemplate,
    },
    mixins: [
        UserTypeMixin,
    ],

    data() {
        return {
            thiscontext: this,
        };
    },

    mounted() { },

    methods: {
        emitClick() {
            this.$emit('click', this.item);
        },



        async toggleUserActive() {
            this.item.loading = true;
            var response = await clientAPI.methods.changeUserActive(this.item.Id)
            this.item.loading = false;
            this.$emit('change', response)
        },

        async sendSetPasswordToDefaultMail() {
            this.item.loading = true;
            await clientAPI.methods.setPasswordToDefault(this.item.EmailAdress);
            this.item.loading = false;
        },
    },

    computed: {
        actionlist() {
            var list = [
                // { '#': 1, title: 'Open user in new tab', icon: "mdi-open-in-new", iconsize: 18, hovercolor: "primary", method: "openMachineInNewTab" },
                //{ '#': 2, title: 'Edit user', icon: "mdi-pencil", iconsize: 22, hovercolor: "tertiary", method: "emitClick" },
                //{ '#': 3, title: 'Send set password mail to user', icon: "mdi-email-alert", iconsize: 18, hovercolor: "warning", method: "transferMachineWork" },
                { '#': 4, title: 'Reset password to default', icon: "mdi-form-textbox-password", iconsize: 22, hovercolor: "error", method: "sendSetPasswordToDefaultMail" },
                //{ '#': 5, title: 'Deactivate user', icon: "mdi-account-off", iconsize: 18, hovercolor: "error", method: "remove" },
            ];
            /*
            if (!this.usedMachineIds || this.usedMachineIds.length < 2) {
                list = list.filter(x => x['#'] != 2)
            }^
            */
            return list;
        },

        storeName() {
            var val = '';
            if (this.warehouseList && this.item.StoreId) {
                var store = this.warehouseList.find(x => x.Id == this.item.StoreId);
                val = store ? store.Name : false;
            }
            return val;
        },
    },

    watch: {},
};
</script>

<style scoped>
.deactivated {
    background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) .v-list-item__content {
    color: var(--v-disabled-darken2) !important;
    text-decoration: line-through !important;
}
</style>